import axios from "axios";

const API_URL = "https://backend.itracknet.com/api";

// const API_URL = "http://localhost:5001/api";
 
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const requestUrl = String(config?.url || "");
    const method = String(config?.method || "get").toLowerCase();
    const isShortEscortsRequest = method === "get" && (requestUrl.includes("/users/short-escorts") || requestUrl.includes("/users/all-escorts-data"));

    if (isShortEscortsRequest) {
      config.headers = {
        ...config.headers,
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: "0",
      };
      config.params = {
        ...(config.params || {}),
        _ts: Date.now(),
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      return Promise.reject({
        status: false,
        message: error.response.data?.message || "Server Error",
        code: error.response.status,
      });
    }

    return Promise.reject({
      status: false,
      message: "Network Error",
      code: null,
    });
  }
);

export const SOCKET_URL = API_URL.replace(/\/api\/?$/, "");

export default apiClient;
